import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "../components/Logo";
import { FadeIn } from "../components/Reveal";
import { PRIVACY_SECTIONS, PRIVACY_UPDATED, PRIVACY_INTRO } from "../config/content";

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="min-h-screen bg-ivory px-6 py-10">
      <div className="max-w-md mx-auto">
        <div className="flex items-center justify-between">
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="flex items-center gap-2 text-muted2 transition-colors hover:text-ink"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase">Torna</span>
          </Link>
          <Logo small />
        </div>

        <FadeIn className="mt-14">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-gold">Informativa</p>
          <h1 className="mt-3 font-serif text-4xl text-ink">Privacy Policy</h1>
          <p data-testid="privacy-updated" className="mt-3 font-mono text-[10px] tracking-[0.25em] uppercase text-muted2">
            {PRIVACY_UPDATED}
          </p>
          <p data-testid="privacy-intro" className="mt-6 text-sm leading-relaxed text-muted2">
            {PRIVACY_INTRO}
          </p>
        </FadeIn>

        <div className="mt-12 space-y-10 pb-16">
          {PRIVACY_SECTIONS.map((s, i) => (
            <FadeIn key={s.title} delay={0.1 + i * 0.08}>
              <div className="border-t border-line pt-6">
                <div className="flex items-baseline gap-3">
                  <span className="font-mono text-xs text-gold">{String(i + 1).padStart(2, "0")}</span>
                  <h2 className="font-serif text-xl text-ink">{s.title}</h2>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-muted2 whitespace-pre-line">{s.body}</p>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </div>
  );
}
